import { Box, Button, IconButton, Typography } from "@mui/material";
import FileDrop from "./FileDrop";
import IntentSelectionComponent from "./IntentSelectionComponent";
import { KeyboardDoubleArrowLeft, RadioButtonChecked } from "@mui/icons-material";
import {useNavigate} from "react-router-dom"
import Lottie from "lottie-react";
import loaderAnimation from "./JuneLoader.json";
import PropTypes from "prop-types";
const AssistantSidebar = ({
  disabledFields,
  setUploadedFiles,
  uploadedFiles,
    setSwitchedComponent,
  intentList,
  handleModuleSubmit,
    assistantSidebarOpen,
    setAssistantSidebarOpen,
  handleChatSubmit,
  loading,
  clickedSubmit,
  intentName
}) => {
  const navigate = useNavigate();
  const showIntentLoader = loading && intentList.length === 0;
  return (
    <Box
      sx={{
        flex: {
          xs: "0",
          xl: "0.2",
        },
        display: "flex",
        flexDirection: "column",
        position: {
          xs: "absolute",
          xl: "relative",
        },
        zIndex: "100",
        top: "0",
        left: "0",
        bottom: "0",
        gap: "1rem",
        justifyContent: "space-between",
        paddingBottom: "1rem",
        backgroundColor: "#fefefe",
        height: "100%",
        transform: {
          xs: assistantSidebarOpen ? "translateX(0)" : "translateX(-100%)",
          xl: "translateX(0)",
        },
        width: { xs: "60%", 
          sm: "50%",
          md: "40%",
           xl: "100%" },
        paddingX: "1rem",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        overflow: "auto",
      }}
    >
      <IconButton
        onClick={() => setAssistantSidebarOpen(false)}
        sx={{
          position: "absolute",
          display: { xl: "none" },
          top: "10px",
          right: "10px",
          marginBottom: "10px",
        }}
      >
        <KeyboardDoubleArrowLeft />
      </IconButton>
      <Box>
        <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <img
            src="/images/apps/new-june.svg"
            alt="June Logo"
            style={{ width: "12rem", cursor: "pointer" }}
            onClick={() => setSwitchedComponent(false)}
          />
        </div>
        <Box sx={{ mt: ".8rem" }}>
          <Box sx={{ mt: 3 }}>
            <Box sx={{ mt: 2 }}>
              <Box
                sx={{
                  mt: 1,
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 1,
                }}
              >
                {showIntentLoader ? (
                  <Box
                    sx={{
                      height: 200,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 1,
                    }}
                  >
                    <Lottie
                      animationData={loaderAnimation}
                      loop={true}
                      style={{ width: 60, height: 60 }}
                    />
                    <Typography variant="body2" color="text.secondary">
                      Hold on! Loading Intents
                    </Typography>
                  </Box>
                ) : (
                <IntentSelectionComponent
                  disabledFields={disabledFields}
                  handleModuleSubmit={handleModuleSubmit}
                  loading={loading}
                  intentList={intentList}
                  setSwitchedComponent={setSwitchedComponent}
                />
              )}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

AssistantSidebar.propTypes = {
  disabledFields: PropTypes.object.isRequired,
  setUploadedFiles: PropTypes.func.isRequired,
  uploadedFiles: PropTypes.array.isRequired,
  setSwitchedComponent: PropTypes.func.isRequired,
  intentList: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  handleModuleSubmit: PropTypes.func.isRequired,
  assistantSidebarOpen: PropTypes.bool.isRequired,
  setAssistantSidebarOpen: PropTypes.func.isRequired,
  handleChatSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  clickedSubmit: PropTypes.shape({
    current: PropTypes.bool,
  }).isRequired,
  intentName: PropTypes.string.isRequired,
};

export default AssistantSidebar;
